function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import MaterialButton from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";
const useStyles = makeStyles(({
  typography
}) => ({
  root: {
    borderRadius: typography.pxToRem(5),
    boxShadow: "2px 2px 3px 0 rgba(0, 0, 0, 0.4)",
    padding: `${typography.pxToRem(11)} ${typography.pxToRem(30)}`
  },
  label: {
    fontSize: typography.pxToRem(11),
    letterSpacing: 0.4,
    lineHeight: 1,
    whiteSpace: "nowrap"
  }
}));
const Button = /*#__PURE__*/React.forwardRef(({
  disabled = false,
  children,
  classes = {},
  ...rest
}, ref) => {
  const styles = useStyles();
  return /*#__PURE__*/React.createElement(MaterialButton, _extends({
    variant: "contained",
    color: "primary",
    disabled: disabled,
    classes: {
      root: clsx(styles.root, classes.root),
      label: clsx(styles.label, classes.label)
    },
    ref: ref
    /* $FlowFixMe This comment suppresses an error found when upgrading
     * Flow to v0.112.0. To view the error, delete this comment and run
     * Flow. */

  }, rest), children);
});
export default Button;